import { IScope } from 'angular';
import { PartialObserver, pipe, tap } from 'rxjs';
import { takeUntilDestroyed } from './take-until-destroyed';

function noop() {}

/**
 * @example
 *
 * ```ts
 *  const ctrl = this;
 *  ctrl.vm = {
 *    showCancelMembership: false,
 *  };
 *
 *  ordersDetailService.vm$.pipe(
 *    safeApply($scope, {
 *      next: vm => {
 *        ctrl.vm = vm;
 *      },
 *    })
 *  ).subscribe();
 * ```
 */
export function safeApply<T>($scope: IScope, observer: PartialObserver<T>) {
  const onNext = observer?.next ?? noop;
  const onError = observer?.error ?? noop;
  const onComplete = observer?.complete ?? noop;

  return pipe(
    tap<T>({
      next: (data) => {
        if ($scope.$$phase || $scope.$root.$$phase) {
          onNext(data);
        } else {
          $scope.$apply(function () {
            onNext(data);
          });
        }
      },
      error: (error) => {
        if ($scope.$$phase || $scope.$root.$$phase) {
          onError(error);
        } else {
          $scope.$apply(function () {
            onError(error);
          });
        }
      },
      complete: () => {
        if ($scope.$$phase || $scope.$root.$$phase) {
          onComplete();
        } else {
          $scope.$apply(function () {
            onComplete();
          });
        }
      },
    }),
    takeUntilDestroyed($scope)
  );
}
